import { getQueryKey } from "./get-query-key";

import type { QueryClient } from "@tanstack/react-query";

function invalidateUseUser(client: QueryClient): void {
    client.invalidateQueries(getQueryKey());
}

export { invalidateUseUser };
